/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React, {memo, useCallback} from 'react';
import Switch from '@ion/dls/src/components/switch/Switch';
import {LabelPlacement} from '../components/switch/Switch';

export type LabelToggleProps = {
  label: string,
  isActive: boolean,
  isDarkLabel: boolean,
  onChange: Function,
  labelPlacement: LabelPlacement
};

/**
 * Defines the Label Toggle component, this component will allow to set the visibility
 * of the labels
 *
 * ```typescript
 *
 *  import LabelToggle from '@ion/dls/src/editor';
 *
 *  <LabelToggle
 *    label={label}
 *    labelPlacement={labelPlacement}
 *    isActive={isActive}
 *    onChangeOpacity={onOpacityChange}
 *    onChange={onChange} />
 *
 * ```
 */
export const LabelToggle = ({label, labelPlacement, isActive, isDarkLabel, onChange}: LabelToggleProps) => {
  const onToggle = useCallback(({target}) => {
    onChange(target.checked);
  }, []);

  return (
    <Switch isDarkLabel={isDarkLabel}
      label={label}
      labelPlacement={labelPlacement}
      checked={isActive}
      onChange={onToggle} />
  );
};

export default memo(LabelToggle); ;
